/**
 * Capture Outlook OAuth callback as early as possible (before Angular auth guards).
 * Used by My Profile popup Link flow when Microsoft redirects back with ?code=.
 */
import {
    OUTLOOK_OAUTH_POPUP_NAME,
    relayOutlookOAuthResultToOpener
} from '@app/shared/utils/outlook-oauth-relay';

export function tryCaptureOutlookOAuthCallback(): boolean {
    try {
        const params = new URLSearchParams(window.location.search || '');
        const code = params.get('code');
        const error = params.get('error');
        if (!code && !error) {
            return false;
        }

        const path = (window.location.pathname || '').toLowerCase();
        const isOutlookRedirectPath =
            path.includes('outlook-oauth-callback') ||
            path.includes('time-tracking');

        let hasOpener = false;
        try {
            hasOpener = !!(window.opener && window.opener !== window);
        } catch {
            hasOpener = false;
        }

        const isOutlookPopup = window.name === OUTLOOK_OAUTH_POPUP_NAME || hasOpener;
        if (!isOutlookRedirectPath && !isOutlookPopup) {
            return false;
        }

        const handled = relayOutlookOAuthResultToOpener(
            code,
            error,
            params.get('error_description')
        );

        if (handled) {
            document.body.innerHTML =
                '<div style="font-family:Segoe UI,Arial,sans-serif;padding:32px;color:#333">' +
                '<h3 style="margin:0 0 8px">Connecting Outlook…</h3>' +
                '<p style="margin:0">You can close this window and return to My Profile.</p>' +
                '</div>';
        }

        return handled;
    } catch {
        return false;
    }
}
